import React from 'react';
import { Routes, Route } from 'react-router-dom';

import lodash from 'lodash';
import moment from 'moment';
import { ClausePage, AppDownloadPage, WithdrawalGuidePage, ChartPage, LangChainPage, AiChatPage, EventPage, MechupPage, AiAgentPage, GuidePage } from '@pages';
import {
  ClauseTemplate,
  AppDownloadTemplate,
  WithdrawalGuideTemplate,
  LangChainTemplate,
  AiChatTemplate,
  PrivacyTemplate,
  UniqueTemplate,
  ThirdPartyTemplate,
  RedirectExternalBrowser,
  AuthRequestTemplate,
  NhisTermTemplate,
  AiAgentTemplate,
  PstLinkGuideTemplate,
  GuideTemplate,
} from '@template';
import { EventDetail } from '@components';
import { getEnv } from '@lib/utils';

const App = () => {
  window._ = lodash;
  window.moment = moment;

  const env = getEnv();

  return (
    <Routes>
      <Route path="/" element={<div />} />

      <Route path="/term" element={<ClausePage />}>
        {/* <Route index element={<ClauseTemplate />} /> */}
        <Route path="privacy" element={<PrivacyTemplate />} />
        <Route path="unique" element={<UniqueTemplate />} />
        <Route path="thirdparty" element={<ThirdPartyTemplate />} />
        <Route path="nhis/:type" element={<NhisTermTemplate />} />
        <Route path=":clseId" element={<ClauseTemplate />} />
      </Route>
      <Route path="/appDownload" element={<AppDownloadPage />}>
        <Route index element={<AppDownloadTemplate />} />
      </Route>
      <Route path="/helpdesk/withdrawal" element={<WithdrawalGuidePage />}>
        <Route index element={<WithdrawalGuideTemplate />} />
      </Route>
      {/* 0.3.0 버전 */}
      <Route path="/ai/chat" element={<AiChatPage />}>
        <Route index element={<AiChatTemplate />} />
      </Route>
      {/* 0.4.0 버전 */}
      <Route path="/ai/agent" element={<AiAgentPage />}>
        <Route index element={<AiAgentTemplate />} />
      </Route>
      <Route path="/evt" element={<EventPage />}>
        <Route path=":evtSrno" element={<EventDetail />} />
      </Route>
      {/* 피보호자 인증 라우트 */}
      <Route path="/link" element={<MechupPage />}>
        {/* 접속시 외부 브라우저 연결 */}
        {/* http://localhost:3300/link/guide/HIRA_MEDICATION?data=300000393;300000440/}
        {/* http://10.10.7.169:3300/link?url=http://10.10.7.169:3300/link/guide/HIRA_MEDICATION?data=300000393;300000440 */}
        <Route path="" element={<RedirectExternalBrowser />} />
        {/* 설명 */}
        <Route path="guide/:reqCd" element={<AuthRequestTemplate />} />
        {/* 본인인증 3단계 */}
        <Route path="auth/:reqCd" element={<></>} />
        {/* <Route path="test" element={<PstDeepLinkTemplate />} /> */}
      </Route>

      <Route path="/guide" element={<GuidePage />}>
        <Route path=":ptnId" element={<GuideTemplate />} />
      </Route>

      {/* 테스트용 */}
      {env.NODE_ENV === 'development' && (
        <Route path="/test/langchain" element={<LangChainPage />}>
          <Route index element={<LangChainTemplate />} />
        </Route>
      )}
    </Routes>
  );
};

export default App;
